'use client';
import React, { useEffect, useState } from 'react';

import { SessionContext } from '@benzinga/session-context';
import { JsonLd } from '@benzinga/seo';
import { GeoTracker } from '@benzinga/analytics';

import { NoFirstRender } from '@benzinga/hooks';
import { formatNavigationSchema } from '@benzinga/frontend-utils';
import { AuthPortal } from '@benzinga/auth-ui';
import { menus } from '@benzinga/navigation-ui';
import type { PageConfig } from '../page/pageConfig';
import { GlobalTracking } from '../../../src/components/Tracking/GlobalTracking';

interface RootTrackerProps {
  pageProps?: PageConfig;
}

const RootTracker: React.FC<RootTrackerProps> = ({ pageProps }) => {
  const session = React.useContext(SessionContext);

  return (
    <>
      <GlobalTracking pageProps={pageProps ?? {}} session={session.getSession()} />
      <NoFirstRender>
        <React.Suspense fallback={null}>
          <GeoTracker />
          <AuthPortal />
        </React.Suspense>
      </NoFirstRender>
      <JsonLd data={formatNavigationSchema(menus.primary)} id="navigation-header-schema" />
    </>
  );
};

export default RootTracker;
